import { render, staticRenderFns } from "./SettingWizard.vue?vue&type=template&id=5cf7cf06&"
import script from "./SettingWizard.vue?vue&type=script&lang=js&"
export * from "./SettingWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports